import { render, staticRenderFns } from "./mocReview.vue?vue&type=template&id=9d2a35c8"
import script from "./mocReview.vue?vue&type=script&lang=js"
export * from "./mocReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d2a35c8')) {
      api.createRecord('9d2a35c8', component.options)
    } else {
      api.reload('9d2a35c8', component.options)
    }
    module.hot.accept("./mocReview.vue?vue&type=template&id=9d2a35c8", function () {
      api.rerender('9d2a35c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocReview.vue"
export default component.exports